const fonts = {
  default: 'Nunito Sans, sans-serif',
}

export { fonts }
